import React from 'react';
import {
  NavItem,
  Nav,
  Col,
  Tab,
  Row,
} from 'react-bootstrap';
import { browserHistory } from 'react-router';
import TourHotelSelectTab from './TourHotelSelectTabContainer';
import TourHotelSendTab from './TourHotelSendTabContainer';
import TourHotelManageTab from './TourHotelManageTab';

class TourHotelTab extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(detailTab) {
    if (detailTab === 1) {
      // Handle legacy tab numbering
      const url = `/tours/${this.props.tour.id}/hotels/2`;
      browserHistory.push(url);
      return;
    }
    const url = `/tours/${this.props.tour.id}/hotels/${detailTab}`;
    browserHistory.push(url);
  }

  render() {
    const activeKey = this.props.detailTab ? this.props.detailTab : '2';
    return (
      <div className="col-sm-12 planner">
        <Tab.Container
          id="tabs-with-dropdown"
          activeKey={activeKey}
          onSelect={this.handleSelect}
        >
          <Row className="clearfix">
            <Col sm={12}>
              <Nav bsStyle="tabs">
                <NavItem eventKey="2">
                  <span>1</span> Select Hotels
                 </NavItem>
                <NavItem eventKey="3" >
                  <span>2</span> Request Bids
                 </NavItem>
                <NavItem eventKey="4">
                  <span>3</span> Manage Bids
                 </NavItem>
              </Nav>
            </Col>
            <Col sm={12}>
              <Tab.Content animation>
                <Tab.Pane eventKey="2" mountOnEnter>
                  <TourHotelSelectTab tour={this.props.tour} />
                </Tab.Pane>
                <Tab.Pane eventKey="3" mountOnEnter>
                  <TourHotelSendTab tour={this.props.tour} />
                </Tab.Pane>
                <Tab.Pane eventKey="4" mountOnEnter>
                  <TourHotelManageTab
                    tour={this.props.tour}
                    detail={this.props.detailSelect}
                    isTourManager={false}
                    readOnly={this.props.readOnly}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }
}

export default TourHotelTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelTab.js